import {context, propagation, trace} from '@opentelemetry/api';
import PropTypes from 'prop-types';
import {
    CompositePropagator,
    W3CBaggagePropagator,
    W3CTraceContextPropagator
} from '@opentelemetry/core';
import {resourceFromAttributes} from '@opentelemetry/resources';
import {BatchSpanProcessor, TracerProvider} from '@opentelemetry/sdk-trace';
import {OTLPTraceExporter} from '@opentelemetry/exporter-trace-otlp-http';
import {registerInstrumentations} from '@opentelemetry/instrumentation';
import {FetchInstrumentation} from '@opentelemetry/instrumentation-fetch';
import {ATTR_SERVICE_NAME} from '@opentelemetry/semantic-conventions';
import {ZoneContextManager} from '@opentelemetry/context-zone';
import {ATTR_SERVICE_INSTANCE_ID} from "@opentelemetry/semantic-conventions/incubating";
import {DocumentLoadInstrumentation} from '@opentelemetry/instrumentation-document-load';
import {UserInteractionInstrumentation} from '@opentelemetry/instrumentation-user-interaction';

const collectorExporter = new OTLPTraceExporter({
    url: window.ENV.OTLP_URL,
    headers: {
        'X-Scope-OrgID': 'synapse42'
    }
});

const provider = new TracerProvider({
    resource: resourceFromAttributes({
        [ATTR_SERVICE_NAME]: window.ENV.SERVICE_NAME,
        [ATTR_SERVICE_INSTANCE_ID]: window.ENV.SERVICE_INSTANCE_ID,
        'environment': window.ENV.ENVIRONMENT,
    }),
    spanProcessors: [new BatchSpanProcessor({
        exporter: collectorExporter,
        maxQueueSize: 2048,
        maxExportBatchSize: 512,
        scheduledDelayMillis: 1000,
        exportTimeoutMillis: 30000
    })]
});

context.setGlobalContextManager(new ZoneContextManager());
propagation.setGlobalPropagator(new CompositePropagator({
    propagators: [new W3CTraceContextPropagator(), new W3CBaggagePropagator()]
}));
trace.setGlobalTracerProvider(provider);

const fetchInstrumentation = new FetchInstrumentation({
    propagateTraceHeaderCorsUrls: [
        new RegExp(window.ENV.BACKEND_URL)
    ],
    clearTimingResources: true
});
fetchInstrumentation.setTracerProvider(provider);

registerInstrumentations({
    instrumentations: [
        new DocumentLoadInstrumentation(),
        new UserInteractionInstrumentation(),
        fetchInstrumentation
    ],
    tracerProvider: provider
});

export default function TraceProvider({children}) {
    return (
        <>
            {children}
        </>
    );
}

TraceProvider.propTypes = {children: PropTypes.node};
